  import React from "react";
  const DetailedLOPerformance = (props) => {

  const Table = ({ title, color, data }) => (
    <div className="lo-section">
      <h3 style={{ color }}>
        <span className="dot" style={{ background: color }}></span>
        {title}
      </h3>

      <div className="lo-table-wrapper">
        <table className={`lo-table ${title.includes(props.Data?.[0].subjectName) ? "english" : "maths"}`}>
          <thead>
            <tr>
              <th >Learning Objective</th>
              <th>Qs</th>
              <th>Score %</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {props.Data?.map((item, index) => (
              <tr key={index} onClick={()=> props.GetLovid(item.loId,item.subjectName)}>
                <td>{item.learningOutcome}</td>

                <td>{item.questionNo}</td>

                <td
                  className={
                    item.percentage < 60 ? "score-red" : "score-green"
                  }
                >
                  {item.percentage}%
                </td>

                <td>
                  <span
                    className={
                      item.status === "Prof"
                        ? "status-green"
                        : "status-red"
                    }
                  >
                    {item.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

    return (
      <div className="lo-card">
        <h2>
          📋 Detailed LO Performance Breakdown
        </h2>

        <p className="subtitle">
          Learning Objectives sorted by performance percentage in ascending
          order. Click any row below to view specific student details.
        </p>

        <div className="lo-grid">
          {props.Data?.[0].subjectName == "English" ? 
          <Table
            title="English Learning Objectives"
            color="#16a34a"
            // data={englishData}
          />
  :
          <Table
            title="Mathematics Learning Objectives"
            color="#2563eb"
            // data={mathsData}
          />}
        </div>
      </div>
    );
  }
  export default DetailedLOPerformance;